module.exports = __webpack_public_path__ + "img/hopways.17431403.jpeg";